export enum EndpointType {
  GET = 0,
  POST = 1,
  PATCH = 2,
  DELETE = 3
}
